﻿import { ajaxGet, ajaxPost, ajaxPostWithJSON } from '../utils/ajax';

export default {
    getLogin(url, callback, errorCallback) {
        ajaxGet(url)
            .then(callback)
            .catch(errorCallback);
    },
}
